// Empty State Translations for Transactions Page
export const emptyStateTranslations = {
  en: {
    // All variants use the same title
    emptyTransactions: "Empty Transactions",
    
    // Common
    selected: "selected",
    noTransactionsForReport: "No transactions found for the selected criteria. Please adjust your filters and try again.",
  },
  ar: {
    // All variants use the same title
    emptyTransactions: "معاملات فارغة",
    
    // Common
    selected: "محدد",
    noTransactionsForReport: "لم يتم العثور على معاملات للمعايير المحددة. يرجى تعديل الفلاتر والمحاولة مرة أخرى.",
  }
};

// Helper function to add these translations to i18n
export const addEmptyStateTranslations = (i18n: any) => {
  Object.keys(emptyStateTranslations).forEach((lang) => {
    i18n.addResources(lang, 'translation', emptyStateTranslations[lang as keyof typeof emptyStateTranslations]);
  });
};
